import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export function AdminLoginDialog({ open, onOpenChange }) {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) {
      toast.success("Accesso admin effettuato");
      onOpenChange(false);
      setPassword("");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-slate-900/95 backdrop-blur-xl border border-white/10 text-slate-100"
        data-testid="admin-login-dialog"
      >
        <DialogHeader>
          <div className="w-11 h-11 rounded-xl bg-emerald-500/15 flex items-center justify-center mb-2">
            <Lock className="w-5 h-5 text-emerald-400" />
          </div>
          <DialogTitle className="font-display text-2xl uppercase tracking-tight">
            Accesso Amministratore
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Inserisci le credenziali per gestire i risultati del campionato.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-2">
          <div className="space-y-1.5">
            <Label className="text-slate-300 text-xs uppercase tracking-wider">Email</Label>
            <Input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@americanpadel.it"
              className="bg-slate-900 border-slate-700 focus-visible:ring-emerald-500"
              required
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-slate-300 text-xs uppercase tracking-wider">Password</Label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="bg-slate-900 border-slate-700 focus-visible:ring-emerald-500"
              required
            />
          </div>
          <Button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold uppercase tracking-wide"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entra"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
